import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ButtonComponent from "../../components/Elements/Button/Button";
import "./JobCart.css";
import { Padding } from "@mui/icons-material";
import Icon from "../../components/Elements/Icon/Icon";
import Images from "../../constant/images";
import FileUploadForm from "../../components/Elements/ResumeUplode/ResumeUplode";
import Dropdown from "../../components/Elements/Dropdown/Dropdown";
import Card from "../../components/Elements/Card/Card";
import { EMAIL_REGEX, PHONE_REGEX, SHEET_API_URL } from "../../utils/Regex";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Input from "../../components/Elements/Input/Input";
import { useLocation } from "react-router-dom";

const Dropresume = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { job } = location.state || {};
  console.log("Received Job:", job);
  const experienceOptions = [
    { label: "Fresher", value: "0" },
    { label: "0-1 Years", value: "0-1" },
    { label: "1-3 Years", value: "1-3" },
    { label: "3-5 Years", value: "3-5" },
    { label: "5-10 Years", value: "5-10" },
    { label: "10+ Years", value: "10_plus" },
  ];
  const designations = [
    { label: "Software Engineer", value: "software_engineer" },
    { label: "Senior Developer", value: "senior_developer" },
    { label: "Team Lead", value: "team_lead" },
    { label: "Project Manager", value: "project_manager" },
    { label: "CTO", value: "cto" },
    { label: "Other", value: "other" },
  ];

  const nationalities = [
    { label: "Indian", value: "indian" },
    { label: "American", value: "american" },
    { label: "Canadian", value: "canadian" },
    { label: "British", value: "british" },
    { label: "Other", value: "other" },
  ];
  
  const industries = [
    { label: "Information Technology", value: "it" },
    { label: "Healthcare", value: "healthcare" },
    { label: "Finance", value: "finance" },
    { label: "Education", value: "education" },
    { label: "Retail", value: "retail" },
    { label: "Manufacturing", value: "manufacturing" },
    { label: "Real Estate", value: "real_estate" },
    { label: "Other", value: "other" },
  ];
  
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [selectedFile, setSelectedFile] = useState<any>(null);
  const formFields = [
    {
      label: t("contacts.fullName"),
      placeholder: t("contacts.fullName"),
      name: "fullName",
      isDropdown: false,
    },
    {
      label: t("contacts.email"),
      placeholder: t("contacts.email"),
      name: "email",
      isDropdown: false,
    },
    {
      label: t("contacts.phone"),
      placeholder: t("contacts.phone"),
      name: "phone",
      isDropdown: false,
    },
    {
      label: "Experience",
      placeholder: "Select Experience",
      name: "experience",
      isDropdown: true,
    },
    {
      label: "Nationality*",
      placeholder: "Select Nationality",
      name: "nationality",
      isDropdown: true,
    },
    {
      label: "Current Designation",
      placeholder: "Select Destination",
      name: "currentdesignation",
      isDropdown: true,
    },
  ];
  console.log("selectedFile", selectedFile);
  const validate = (values: any) => {
    const errors: any = {};
if (!values.fullName.trimStart()) {
  errors.fullName = "Full Name is required";
} else if (!/^[A-Za-z\s]+$/.test(values.fullName.trimStart())) {
  errors.fullName = "Only letters and spaces are allowed";
}
    if (!values.email) errors.email = "Email is required";
    else if (!EMAIL_REGEX.test(values.email))
      errors.email = "Invalid email address";

    if (!values.phone) errors.phone = "Phone number is required";
    else if (!PHONE_REGEX.test(values.phone))
      errors.phone = "Contact number must be 10 digits";

    if (!values.Industry) errors.Industry = "Industry is required";

    if (!values.experience) errors.experience = "Experience is required";
    if (!values.nationality) errors.nationality = "nationality is required";
    if (!values.currentdesignation) errors.currentdesignation = "currentdesignation is required";

    // if (!values.message) errors.message = "Message is required";

    if (!values.resume) errors.resume = "Resume is required";

    return errors;
  };

 
  const uploadResumeAndGetURL = async (file: File | null): Promise<string | null> => {
    if (!file) return null;
  
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onloadend = async () => {
        if (typeof reader.result === "string") {
          const base64 = reader.result.split(",")[1];
          const formData = new FormData();
          formData.append("base64", base64);
          formData.append("filename", file.name);
          formData.append("mimeType", file.type);
  
          try {
            const response = await axios.post(
              `${SHEET_API_URL}?action=doPostResume`,
              formData
            );
            if (response.data.success) {
              resolve(response.data.url); // ✅ return the URL
            } else {
              reject("Upload failed: " + response.data.error);
            }
          } catch (error) {
            reject("Upload failed: " + error);
          }
        } else {
          reject("Error: File reading failed.");
        }
      };
  
      reader.readAsDataURL(file);
    });
  };
  

  const formik = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      phone: "",
      experience: "",
      Industry: "",
      nationality:"",
      currentdesignation:"",
      // message: "",
      resume: "", // ✅ URL store karne ke liye
    },
    validate,

  
    onSubmit: async (values,{resetForm}) => {
      setIsSubmitting(true);
    
      try {
        // ✅ Upload and wait for the resume URL
        const resumeUrl = await uploadResumeAndGetURL(selectedFile);
    
        if (!resumeUrl || typeof resumeUrl !== "string") {
          toast.error("Resume upload failed.");
          setIsSubmitting(false);
          return;
        }
    
        const payload = {
          fullName: values.fullName,
          emailId: values.email,
          phoneNumber: values.phone,
          experience: values.experience,
          nationality:values.nationality,
          message:"",
          designation:values.currentdesignation,
          industry:values.Industry,
          resume: resumeUrl, // ✅ Use the uploaded URL
        };
    
        const response = await axios.post(
          `${SHEET_API_URL}?action=doPostDrop`,
          JSON.stringify(payload)
        );
    
        if (response.data.success) {
          toast.success(
            "We’ve received your application and we’ll forward for suitable job opportunities."

          );
          resetForm(); // 👈 Reset the form here

        } else {
          toast.error("Something went wrong. Please try again.");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("Error submitting form. Please check console.");
      } finally {
        setIsSubmitting(false);
      }
    },
    
  });


  return (
    <>
      <ToastContainer position="top-center" autoClose={4000} />

      <Box
        className="opening-main-job"
        flexDirection={"column"}
        sx={{ heigh: "220px !important" }}
      >
        <Typography className="opening-heading"             textTransform={"capitalize"}
        >
        {job.jobTitle}
        </Typography>
        <Box display={"flex"} gap={1} mt={1}>
          <LocationOnIcon fontSize="small" sx={{ color: "white" }} />
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ color: "white" }}
            textTransform={"capitalize"}

          >
            {job.location}
            </Typography>
        </Box>
      </Box>
      <Box>
        {" "}
        <Box className="form-container">
          <Box
            bgcolor={"#741374"}
            padding={"20px"}
            mt={5}
            boxShadow={"0px 0px 20px 0px #00000040;"}
          ></Box>
          <Card className={"form-card"}>
            <Typography variant="h6" className="pp">
              Drop Your Resume With Us{" "}
            </Typography>
            <form
              className="formStyle"
              onSubmit={(e) => {
                e.preventDefault();
                console.log("🔵 Form onSubmit triggered");
                console.log("⚠️ Form errors:", formik.errors); // ✅ Check if there are errors
                formik.handleSubmit();
              }}
            >
              <Box className="form-input-container">
              <Grid container spacing={4} justifyContent="space-between">
                {formFields.map((input, index) => (
                  <Grid item xs={12} sm={12} md={6} key={index}>
                    {/* <label htmlFor={input.name} style={{ display: "block", marginBottom: "8px" }}>
                    {input.label}
                  </label> */}
                    {input.isDropdown ? (
                      <Dropdown
                      className="Login"
                      placeholder={input.placeholder}
                        name={input.name}
                        id={input.name}
                        label={
                          input.label
                        }
                        options={
                          input.name === "experience"
                            ? experienceOptions
                            : input.name === "nationality"
                            ? nationalities
                            : designations // default fallback
                        }                     
                        onHandleChange={(value: string) => {
                          formik.setFieldValue(input.name, value);
                          // formik.setTouched({ ...formik.touched, [input.name]: true });
                        }}
                        value={(formik as any).values[input.name]}
                        error={
                          (formik as any).errors[input.name] &&
                          (formik as any).touched[input.name]
                            ? (formik as any).errors[input.name]
                            : ""
                        }
                        onBlur={formik.handleBlur}
                        touched={(formik as any).touched[input.name]}
                      />
                    ) : (
                      <Input
                        className="Login"
                        label={input.label}
                        placeholder={input.placeholder}
                        name={input.name}
                        id={input.name}
                        value={(formik as any)?.values[input.name]}
                        onChange={formik.handleChange}
                        error={
                          (formik as any).errors[input.name] &&
                          (formik as any).touched[input.name]
                            ? (formik as any).errors[input.name]
                            : ""
                        }
                        onBlur={formik.handleBlur}
                        touched={(formik as any).touched[input.name]}
                      />
                    )}
                  </Grid>
                ))}
                <Grid item xs={12} width={"100%"}>
                  <Dropdown
                      className="Login"
                      // placeholder={t("contacts.nationality")}
                    placeholder="Select Industry"
                    name="Industry"
                    id="Industry"
                    label={"                        Industry"
                      // <>
                      //   {/* {t("contacts.nationality")}{" "} */}
                      //   Industry
                      //   {/* <span style={{ color: "#000" }}>*</span> */}
                      // </>
                    }
                    options={industries}
                    // onHandleChange={(event: any) => {
                    //   formik.setFieldValue("Industry", event.target.value);
                    //   formik.setTouched({
                    //     ...formik.touched,
                    //     Industry: true,
                    //   });
                    // }}
                    onHandleChange={(value: string) => {
                      formik.setFieldValue("Industry", value);
                      // formik.setTouched({ ...formik.touched, [input.name]: true });
                    }}
                    value={formik.values.Industry}
                    error={
                      (formik as any).errors.Industry && (formik as any).touched.Industry
                        ? (formik as any).errors.Industry
                        : ""
                    }
                    onBlur={formik.handleBlur}
                    touched={(formik as any).touched.Industry}
                  />
                </Grid>

                {/*  */}

                <Grid item xs={12}>
                  {/* File Upload with Validation */}
                  {/* <FileUploadForm setSelectedFile={setSelectedFile} /> */}
                  <FileUploadForm
                    setSelectedFile={setSelectedFile}
                    setFieldValue={formik.setFieldValue} // ✅ Pass Formik function
                  />

                  {(formik as any)?.errors.resume && (
                    <Typography color="error" variant="body2">
                      {(formik as any)?.errors.resume}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <ButtonComponent
                    type="submit" // ✅ Ensure this is set
                    className={"HireButton"}
                    disable={isSubmitting}
                    style={{
                      background: "#741374",
                      color: "white",
                      width: "130px !important",
                      height: "48px !important",
                      fontSize: "18px !important",
                    }}
                  >
                    {isSubmitting ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      "Apply"
                    )}

                    {/* {t("application.apply")} */}
                  </ButtonComponent>
                </Grid>
              </Grid>
            </Box>
            </form>
          </Card>
        </Box>
      </Box>
    </>
  );
};
export default Dropresume;
